import { Link } from '@tanstack/react-router'

import { ChevronLeft } from 'lucide-react'

import { Section, SectionTitle } from '@/features/app-shell/section'

import { Button } from '@/components/ui/button'
import { Skeleton } from '@/components/ui/skeleton'

/**
 * The automation form's `Suspense` fallback — the form itself is `lazy`, this
 * is not, which is why the shape lives in a separate file (P-21).
 */
export const AutomationSettingsFormSkeleton = () => {
	return (
		<div className="flex w-full flex-col items-start justify-start gap-4">
			<Skeleton className="h-32 w-full" />
			<Skeleton className="h-64 w-full" />
			<Skeleton className="h-64 w-full" />
			<Skeleton className="h-64 w-full" />
		</div>
	)
}

/**
 * The "New Automation" route's `pendingComponent`. Mirrors the real page's
 * chrome (back button + title) verbatim — same `Button render={<Link>}`, not
 * `asChild` (this repo is Base UI) — then drops in the form skeleton above.
 */
export const AutomationSettingsNewSkeleton = () => {
	return (
		<Section>
			<div className="flex items-start justify-start gap-4">
				<Button
					variant="outline"
					size="icon"
					render={
						<Link to="/air/automation-settings">
							<ChevronLeft size="16" />
						</Link>
					}
				/>

				<SectionTitle>Create New Automation</SectionTitle>
			</div>

			<div className="flex w-full flex-col items-start justify-start gap-2">
				<AutomationSettingsFormSkeleton />
			</div>
		</Section>
	)
}
